
export default {
  props: {
    slides: {
      type: Array,
      required: true,
      default: () => []
    },
    carouselModel: {
      type: Number,
      required: false,
      default: () => 0
    }
  },
  data() {
    return {
      activeSlide: this.carouselModel
    }
  },
  computed: {
    cssVars() {
      return {
        '--progress-bar-position': (100 / (this.slides.length > 0 ? this.slides.length : 1)) * (this.carouselModel) + '%'
      }
    }
  },
  methods: {
    goToUrl(url){
      this.$router.push(url)
    }
  }
}
